import { Col, Row,} from "antd";
import MostViewedAdType from "./Components/MostViewedAdType/MostViewedAdType";
import TopFilters from "../MarketAnalysis/Components/TopFilters";
import PageTitle from "apps/Common/PageTitle";
import MobileTopFilters from "./Components/MobileTopFilters";

const MarketAnalysisIndex = () => {
  return (
    <>
      <Col span={24} className="!mt-4">
        <Row gutter={[20, 20]}>
          
          <Col xs={24} className="!hidden md:!block" >
          <TopFilters isMobile={false}/>
        </Col>
        <Col xs={24} className="!block md:!hidden" >
        <MobileTopFilters/>
        </Col>

          <Col xs={24} lg={8}>
            <MostViewedAdType />
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default MarketAnalysisIndex;
